import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetTagsSucceed, EGetTagsActionType } from './types';
import { ITagDataSchema } from '../../../repositories/journal/entities/tag/TagDataSchema';

export const getTagsSucceed: (items: ITagDataSchema[]) => TGetTagsSucceed = actionGenerator<
  EGetTagsActionType.Succeed,
  ITagDataSchema[]
>(EGetTagsActionType.Succeed);
